module.exports = __webpack_public_path__ + "static/cover-prices-f98aa3ec7d52dc2b3a05a5bb9a3bcd17.jpg";